// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GZKu","content":"styles_content__13ltn","tableWrap":"styles_tableWrap__18zRi"};